/*eslint-disable*/
import React, { useEffect, useState, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import GridContainer from "components/Grid/GridContainer.js";
import { useLocation, useNavigate } from "react-router-dom";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import { Paper, Typography } from "@material-ui/core";
import GridItem from "components/Grid/GridItem.js";
import moment from "moment";
import {
  Row,
  Col,
  Label,
  CardBody,
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  Form,
  FormGroup,
  Input,
  FormText,
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown
} from "reactstrap";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import {
  Grid,
  Button,
  TextField,
} from "@material-ui/core";
import AddBoxRounded from "@material-ui/icons/AddBoxRounded";
import { FirebaseContext } from "common";
import { features, language,STYLES } from "config";
const BranchStatistics = () => {


  const navigate = useNavigate();
  const location = useLocation();
  const branch = location.state; // Retrieve passed branch data


  //   useEffect(() => {
  //     setdetails(location.state);
  //     console.log("details", location.state);
  //   }, []);

  if (!branch) {
    return (
      <div>
        <h1>THIS PAGE IS COMING SOON</h1>
        <Button color="secondary" onClick={() => navigate(-1)}>Go Back</Button>
      </div>
    );
  }





  return (
    <>


      <Row>


        <Card
          style={{
            backgroundColor:STYLES.PRIMARY_APP_CLR,
            width: "100%",
            height: "20%"
          }}
        >
          <CardHeader>
            <CardTitle tag="h4" style={{ color: "white" }}>
              Branch Statistics
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Container>
              {!branch ? (
                <>
                  <h1>THIS PAGE IS COMING SOON</h1>
                  <Button color="secondary" onClick={() => navigate(-1)}>
                    Go Back
                  </Button>
                </>
              ) : (
                <>
                  <h1>{branch.BranchName} Details</h1>
                  <Row>

                  </Row>
                  <Button color="secondary" onClick={() => navigate(-1)}>
                    Back to Branches Page
                  </Button>
                </>
              )}
            </Container>

          </CardBody>
        </Card>


      </Row>



    </>

  );
};

export default BranchStatistics;